import React from 'react';

import RufsError from '../../../errors/rufsError.jsx';

const PaymentError = () => (
    <RufsError>
        Vi får ikke til å sende ditt avslag akkurat nå. Prøv igjen om litt.
    </RufsError>
);

export default PaymentError;



// WEBPACK FOOTER //
// ./safeTrade/seller/agreement/errors/rejectAgreementError.jsx